export default [ 
    ///DONE /////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    //FOR Contract Manager [BRANCH USER]========================================================================
    {
        key: "New Contracts",
        status: "New Contracts",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "edit",

                buttonLabel: "Edit",
                color: 'warning',
                icon: "icon-edit",
                btnSize: "large",

            },
            {
                buttonType: "action", //if relay it means it will just emit an event to show data. if action it will update db info
                endPoint: "deletePr",
                payLoad: {
                    id: "", //record Id To Update 
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "Delete Confirmation",
                rejectReasonMessage: "Why Are you Deleting this Contract?",

                buttonLabel: "Delete",
                color: 'danger',
                icon: "icon-trash",
                btnSize: "large",

                confirmationTitle: "Rejection",
                confirmationMessage: "Are you sure you want to Delete this Contract?",
                successMessage: "This Contract has been successfully Deleted",

                sucessEventName: "changeView",
                successEventValue: "list",
            }

        ]

    },
   
    {
        subject: "contract",
        key: "submittedToHOD",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            }, 
        ]

    },
   
    {
        subject: "contract",
        key: "ProcApprovedContract",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        subject: "contract",
        key: "ProcRejectedContract",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        subject: "contract",
        key: "HODApprovedContract",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },
    {
        subject: "contract",
        key: "HODRejectedContract",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "",

        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },

    //---------------------------------------------------------------------------------------------------------


    //FOR HOD Contract Approver========================================================================
    {
        subject: "contract",
        key: "HOD Pending Contract",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "",
        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]
    },
    {
        subject: "contract",
        key: "HOD Approved Contract",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "",
        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]
    },
    {
        subject: "contract",
        key: "HOD Rejected Contract",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "",
        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]
    },
    //----------------------------------------------------------------------------------------------------------


    //FOR Contract Approver [PROCUREMENT TEAM]======================================================================== 
    {
        subject: "contract",
        key: "Proc Rejected Contract",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "",
        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]

    },

    {
        subject: "contract",
        key: "Proc Approved Contracts",
        label: "Main Information",
        showInvoicePreview: false,   //this is unique to PR data
        invoiceTitle: "",
        actionButtons: [
            {
                buttonType: "relay", //if relay it means it will just emit an event to show data. if action it will update db info
                eventName: "changeView",
                eventValue: "list",

                buttonLabel: "Back To List",
                color: 'primary',
                icon: "icon-arrow-left-circle",
                btnSize: "large",

            },

        ]
    },


]